import * as React from 'react';
import PublicHeader from './PublicHeader';

export const BusinessHeader = () => (
  <PublicHeader
    title="Filtru for Business"
    subtitle="Connect your brand with a specialty coffee community"
  />
);

export default BusinessHeader;
